import React, { useState, useEffect } from 'react';
import { ShoppingCart, X } from 'lucide-react';

const CheckoutPopup = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  // Nama-nama Melayu
  const names = [
    'Ahmad', 'Muhammad', 'Mohd', 'Ali', 'Abu', 'Ibrahim', 'Ismail', 'Hassan',
    'Hussein', 'Omar', 'Yusof', 'Zainol', 'Aziz', 'Rahman', 'Karim', 'Razak', 
    'Hafiz', 'Amir', 'Imran', 'Faisal', 'Hakim', 'Rahim', 'Zulkifli', 'Nordin', 
    'Hamid', 'Kamal', 'Nasir', 'Rosli', 'Samad', 'Bakar', 'Jalil', 'Zainal',
    'Azman', 'Zamri', 'Fairuz', 'Shahrul', 'Faizal', 'Khairul', 'Syahir', 'Izzat',
    'Afiq', 'Fikri', 'Haziq', 'Irfan', 'Danial', 'Luqman', 'Hakimi', 'Safwan',
    'Arif', 'Amirul', 'Syafiq', 'Nazri', 'Ridwan', 'Fahmi', 'Ashraf', 'Zaki',
    'Fatimah', 'Aminah', 'Siti', 'Nurul', 'Aisyah', 'Zahra', 'Khadijah', 'Maryam',
    'Sarah', 'Nadia', 'Ain', 'Aina', 'Aishah', 'Alya', 'Amira', 'Anisa',
    'Balqis', 'Diana', 'Farah', 'Hana', 'Izzah', 'Jannah', 'Liyana', 'Mariam',
    'Nabila', 'Najwa', 'Nisa', 'Nur', 'Puteri', 'Qistina', 'Raihana', 'Safiya',
    'Syahirah', 'Syakirah', 'Umairah', 'Wani', 'Yasmin', 'Zara', 'Zulaikha',
    'Haslinda', 'Noraini', 'Rosmah', 'Zarina', 'Suraya', 'Zalina', 'Rohana'
  ];

  // Malaysian locations with states - fokus Semenanjung
  const locations = [
    // JOHOR - banyak kawasan
    { area: 'Johor Bahru', state: 'Johor' },
    { area: 'Iskandar Puteri', state: 'Johor' },
    { area: 'Pasir Gudang', state: 'Johor' },
    { area: 'Kulai', state: 'Johor' },
    { area: 'Pontian', state: 'Johor' },
    { area: 'Muar', state: 'Johor' },
    { area: 'Batu Pahat', state: 'Johor' },
    { area: 'Kluang', state: 'Johor' },
    { area: 'Segamat', state: 'Johor' },
    { area: 'Mersing', state: 'Johor' },
    { area: 'Kota Tinggi', state: 'Johor' },
    { area: 'Tangkak', state: 'Johor' },
    { area: 'Senai', state: 'Johor' },
    { area: 'Skudai', state: 'Johor' },
    { area: 'Gelang Patah', state: 'Johor' },
    { area: 'Ulu Tiram', state: 'Johor' },
    { area: 'Masai', state: 'Johor' },
    { area: 'Permas Jaya', state: 'Johor' },
    { area: 'Tampoi', state: 'Johor' },
    { area: 'Larkin', state: 'Johor' },
    
    // SELANGOR - banyak kawasan
    { area: 'Petaling Jaya', state: 'Selangor' },
    { area: 'Shah Alam', state: 'Selangor' },
    { area: 'Subang Jaya', state: 'Selangor' },
    { area: 'Klang', state: 'Selangor' },
    { area: 'Puchong', state: 'Selangor' },
    { area: 'Kajang', state: 'Selangor' },
    { area: 'Bangi', state: 'Selangor' },
    { area: 'Ampang', state: 'Selangor' },
    { area: 'Rawang', state: 'Selangor' },
    { area: 'Serdang', state: 'Selangor' },
    { area: 'Cyberjaya', state: 'Selangor' },
    { area: 'Semenyih', state: 'Selangor' },
    { area: 'Balakong', state: 'Selangor' },
    { area: 'Seri Kembangan', state: 'Selangor' },
    { area: 'Damansara', state: 'Selangor' },
    { area: 'Kota Damansara', state: 'Selangor' },
    { area: 'Setia Alam', state: 'Selangor' },
    { area: 'Bukit Jelutong', state: 'Selangor' },
    { area: 'Puncak Alam', state: 'Selangor' },
    { area: 'Sepang', state: 'Selangor' },
    { area: 'Dengkil', state: 'Selangor' },
    { area: 'Banting', state: 'Selangor' },
    { area: 'Kuala Selangor', state: 'Selangor' },
    { area: 'Sabak Bernam', state: 'Selangor' },
    { area: 'Hulu Langat', state: 'Selangor' },
    
    // KUALA LUMPUR
    { area: 'Kuala Lumpur', state: 'Kuala Lumpur' },
    { area: 'Cheras', state: 'Kuala Lumpur' },
    { area: 'Kepong', state: 'Kuala Lumpur' },
    { area: 'Setapak', state: 'Kuala Lumpur' },
    { area: 'Wangsa Maju', state: 'Kuala Lumpur' },
    { area: 'Titiwangsa', state: 'Kuala Lumpur' },
    { area: 'Bukit Bintang', state: 'Kuala Lumpur' },
    { area: 'Bangsar', state: 'Kuala Lumpur' },
    { area: 'Mont Kiara', state: 'Kuala Lumpur' },
    { area: 'Sentul', state: 'Kuala Lumpur' },
    { area: 'Segambut', state: 'Kuala Lumpur' },
    { area: 'Sri Petaling', state: 'Kuala Lumpur' },
    { area: 'Bandar Tun Razak', state: 'Kuala Lumpur' },
    
    // PULAU PINANG
    { area: 'Georgetown', state: 'Pulau Pinang' },
    { area: 'Butterworth', state: 'Pulau Pinang' },
    { area: 'Bukit Mertajam', state: 'Pulau Pinang' },
    { area: 'Nibong Tebal', state: 'Pulau Pinang' },
    { area: 'Bayan Lepas', state: 'Pulau Pinang' },
    { area: 'Gelugor', state: 'Pulau Pinang' },
    { area: 'Tanjung Bungah', state: 'Pulau Pinang' },
    { area: 'Air Itam', state: 'Pulau Pinang' },
    { area: 'Jelutong', state: 'Pulau Pinang' },
    { area: 'Kepala Batas', state: 'Pulau Pinang' },
    { area: 'Seberang Jaya', state: 'Pulau Pinang' },
    
    // PERAK
    { area: 'Ipoh', state: 'Perak' },
    { area: 'Taiping', state: 'Perak' },
    { area: 'Teluk Intan', state: 'Perak' },
    { area: 'Kampar', state: 'Perak' },
    { area: 'Lumut', state: 'Perak' },
    { area: 'Sitiawan', state: 'Perak' },
    { area: 'Batu Gajah', state: 'Perak' },
    { area: 'Seri Manjung', state: 'Perak' },
    { area: 'Kuala Kangsar', state: 'Perak' },
    { area: 'Tanjung Malim', state: 'Perak' },
    { area: 'Slim River', state: 'Perak' },
    { area: 'Gopeng', state: 'Perak' },
    { area: 'Parit Buntar', state: 'Perak' },
    
    // KEDAH
    { area: 'Alor Setar', state: 'Kedah' },
    { area: 'Sungai Petani', state: 'Kedah' },
    { area: 'Kulim', state: 'Kedah' },
    { area: 'Langkawi', state: 'Kedah' },
    { area: 'Jitra', state: 'Kedah' },
    { area: 'Kuala Kedah', state: 'Kedah' },
    { area: 'Baling', state: 'Kedah' },
    { area: 'Pendang', state: 'Kedah' },
    { area: 'Yan', state: 'Kedah' },
    { area: 'Pokok Sena', state: 'Kedah' },
    
    // KELANTAN
    { area: 'Kota Bharu', state: 'Kelantan' },
    { area: 'Pasir Mas', state: 'Kelantan' },
    { area: 'Tanah Merah', state: 'Kelantan' },
    { area: 'Machang', state: 'Kelantan' },
    { area: 'Kuala Krai', state: 'Kelantan' },
    { area: 'Tumpat', state: 'Kelantan' },
    { area: 'Bachok', state: 'Kelantan' },
    { area: 'Gua Musang', state: 'Kelantan' },
    { area: 'Pasir Puteh', state: 'Kelantan' },
    
    // TERENGGANU
    { area: 'Kuala Terengganu', state: 'Terengganu' },
    { area: 'Kemaman', state: 'Terengganu' },
    { area: 'Dungun', state: 'Terengganu' },
    { area: 'Marang', state: 'Terengganu' },
    { area: 'Besut', state: 'Terengganu' },
    { area: 'Setiu', state: 'Terengganu' },
    { area: 'Hulu Terengganu', state: 'Terengganu' },
    { area: 'Chukai', state: 'Terengganu' },
    
    // PAHANG
    { area: 'Kuantan', state: 'Pahang' },
    { area: 'Temerloh', state: 'Pahang' },
    { area: 'Bentong', state: 'Pahang' },
    { area: 'Cameron Highlands', state: 'Pahang' },
    { area: 'Raub', state: 'Pahang' },
    { area: 'Jerantut', state: 'Pahang' },
    { area: 'Pekan', state: 'Pahang' },
    { area: 'Lipis', state: 'Pahang' },
    { area: 'Mentakab', state: 'Pahang' },
    { area: 'Rompin', state: 'Pahang' },
    { area: 'Maran', state: 'Pahang' },
    
    // MELAKA
    { area: 'Melaka', state: 'Melaka' },
    { area: 'Alor Gajah', state: 'Melaka' },
    { area: 'Jasin', state: 'Melaka' },
    { area: 'Ayer Keroh', state: 'Melaka' },
    { area: 'Klebang', state: 'Melaka' },
    { area: 'Bukit Beruang', state: 'Melaka' },
    { area: 'Durian Tunggal', state: 'Melaka' },
    { area: 'Masjid Tanah', state: 'Melaka' },
    
    // NEGERI SEMBILAN
    { area: 'Seremban', state: 'Negeri Sembilan' },
    { area: 'Port Dickson', state: 'Negeri Sembilan' },
    { area: 'Nilai', state: 'Negeri Sembilan' },
    { area: 'Bahau', state: 'Negeri Sembilan' },
    { area: 'Kuala Pilah', state: 'Negeri Sembilan' },
    { area: 'Tampin', state: 'Negeri Sembilan' },
    { area: 'Rembau', state: 'Negeri Sembilan' },
    { area: 'Jelebu', state: 'Negeri Sembilan' },
    { area: 'Senawang', state: 'Negeri Sembilan' },
    
    // PERLIS
    { area: 'Kangar', state: 'Perlis' },
    { area: 'Arau', state: 'Perlis' },
    { area: 'Padang Besar', state: 'Perlis' },
    { area: 'Kuala Perlis', state: 'Perlis' },
    
    // PUTRAJAYA
    { area: 'Putrajaya', state: 'Putrajaya' }
  ];

  // Product types
  const products = [
    'Set Sofa Jati', 'Meja Makan Jati', 'Katil Jati', 'Almari Jati',
    'Daybed Jati', 'Kerusi Jati', 'Rak TV Jati', 'Meja Kopi Jati',
    'Set Bilik Tidur', 'Buffet Jati', 'Kabinet Dapur Jati'
  ];

  const generateNotification = () => {
    const name = names[Math.floor(Math.random() * names.length)];
    const location = locations[Math.floor(Math.random() * locations.length)];
    const product = products[Math.floor(Math.random() * products.length)];
    const hoursAgo = Math.floor(Math.random() * 24) + 1; // 1-24 hours
    const time = hoursAgo === 1 ? '1 jam lalu' : `${hoursAgo} jam lalu`;
    
    return { name, location, product, time };
  };

  useEffect(() => {
    // Show first notification after 5 seconds
    const initialTimeout = setTimeout(() => {
      setNotification(generateNotification());
      setIsVisible(true);
    }, 5000);

    // Then show every 5 seconds
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setNotification(generateNotification());
        setIsVisible(true);
      }, 500);
    }, 10500); // 5s visible + 0.5s transition + 5s gap

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  // Auto hide after 5 seconds
  useEffect(() => {
    if (isVisible) {
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }
  }, [isVisible, notification]);

  if (!notification || !isVisible) return null;

  return (
    <div 
      className={`fixed bottom-4 left-4 z-50 transform transition-all duration-300 ${
        isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
    >
      <div className="bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-gray-200 overflow-hidden max-w-xs">
        <div className="px-3 py-2 flex items-center gap-3">
          <div className="flex-shrink-0 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
            {notification.name.charAt(0)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-800">
              <span className="font-semibold">{notification.name}</span> dari <span className="text-[#8B4513] font-medium">{notification.location.state}</span>
            </p>
            <p className="text-xs text-gray-500">
              checkout {notification.product} • {notification.time}
            </p>
          </div>
          <button 
            onClick={() => setIsVisible(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPopup;
